<mat-calendar
  [minDate]="minDate"
  [maxDate]="maxDate"
  [dateFilter]="dateFilter"></mat-calendar>
